import { render, staticRenderFns } from "./unbind.vue?vue&type=template&id=b5543c5e&scoped=true&"
import script from "./unbind.vue?vue&type=script&lang=js&"
export * from "./unbind.vue?vue&type=script&lang=js&"
import style0 from "./unbind.vue?vue&type=style&index=0&id=b5543c5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5543c5e",
  null
  
)

export default component.exports